import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'paginationHelper' })
export class PaginationHelperPipe implements PipeTransform {

  /**
   * @param value value is the total count of entries
   * @param args limit per page
   * Will return one array created with Array(totalNumberOfPages)
   */
  transform(value: any, args?: any): any {
    const totalPages = Math.floor(value / args) + 1;
    return Array(totalPages);
  }
}
